// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconStockChart.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconStockChart = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M6.15385 0H9.84615V16H6.15385V0Z" />
    <path d="M12.3077 4H16V16H12.3077V4Z" />
    <path d="M0 9H3.69231V16H0V9Z" />
  </BaseIcon>
);

export default IconStockChart;
